// Ortak doğrulama yardımcıları.

// Bir metnin e-posta gibi görünüp görünmediğini kabaca kontrol eder.
// (Kesin RFC doğrulaması değil; "e-posta mı yoksa telefon mu?" ayrımı ve
// istemci tarafı ön kontrol için yeterli. Nihai doğrulama backend'de.)
export const looksLikeEmail = (value) => /\S+@\S+\.\S+/.test(value);
